// Global
import React from 'react';

// Local
import { TableOfContents } from './TableOfContents';
import { ComponentParams, Field } from '@sitecore-content-sdk/nextjs';
import { Data } from '@generated/Foundation.GMI.model';
import { Themes } from 'lib/themes';
import useDictionary from 'lib/hooks/useDictionary';
import { useSiteSettings } from 'lib/hooks/useSiteSettings';

type ArticleSettings = Data.Settings.ArticleSettings & {
  fields?: {
    ShowMoreCount?: Field<number>;
  };
};

type TableOfContentsProps = {
  params?: ComponentParams;
};

export const Default = (props: TableOfContentsProps) => {
  const theme = (props.params?.theme as Themes) || undefined;
  const { getDictionaryValue } = useDictionary();
  const siteSettings = useSiteSettings();

  // Heading comes from dictionary (model headline removed)
  const headingKey = 'Components.TableOfContents.Headline';
  const headingValue = getDictionaryValue(headingKey) || 'On this page:';

  // Get configuration from dictionary
  const containerIdKey = 'Components.TableOfContents.ContainerId';
  const containerFromDictionary = getDictionaryValue(containerIdKey)?.trim();
  const containerSelector =
    containerFromDictionary && containerFromDictionary !== containerIdKey
      ? containerFromDictionary
      : 'main-layout-content';

  // Get showMoreCount from Article Settings
  const articleSettings = siteSettings?.articleSettings as ArticleSettings | undefined;
  const showMoreCountValue = articleSettings?.fields?.ShowMoreCount?.value;
  const hideCount =
    typeof showMoreCountValue === 'number' && Number.isFinite(showMoreCountValue)
      ? showMoreCountValue
      : 5;

  const showMore = getDictionaryValue('Components.TableOfContents.ShowMore') || 'Show more';
  const showLess = getDictionaryValue('Components.TableOfContents.ShowLess') || 'Show less';

  return (
    <TableOfContents
      heading={headingValue}
      containerSelector={containerSelector}
      theme={theme}
      hideCount={hideCount}
      showMoreText={showMore}
      showLessText={showLess}
    />
  );
};
